import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom"
import ErrorPage from "../page/errorPage/ErrorPage"
import DashboardHome from "../page/dashboardHome/DashboardHome"
import TitacPoliticasPage from "../page/tictac/TitacPoliticasPage"
import FuelAppPoliticasPage from "../page/fuelApp/FuelAppPoliticasPage"
import NotasSimplesPoliticasPage from "../page/notasSImples/NotasSimplesPoliticasPage"
import ControlGastosPoliticasPage from "../page/controlGastos/ControlGastosPoliticasPage"
import ProductosQuimfaPoliticasPage from "../page/productosQuimfa/ProductosQuimfaPoliticasPage"
import AlmacenMascotasPoliticasPage from "../page/almacenMascotas/AlmacenMascotasPoliticasPage"
import SnakejuegoPage from "../page/appSnakeJuego/SnakejuegoPage"
import OneTravelPoliticasPage from "../page/oneTravel/OneTravelPoliticasPage"
import VaoPuePoliticasPage from "../page/vaoPue/VaoPuePoliticasPage"
import SagaGym from "../page/saga-gym/SagaGym"

function RutesScreen() {

  return (
    <HashRouter>
      <Routes>

        <Route path="/" element={<DashboardHome />} />
        <Route path="/app/tic-tac-toe-politicas-condicion" element={<TitacPoliticasPage />} />
        <Route path="/app/fuel-app-politicas-condicion" element={<FuelAppPoliticasPage />} />
        <Route path="/app/notas-simples-app-politicas-condicion" element={<NotasSimplesPoliticasPage />} />
        <Route path="/app/control-gastos-app-politicas-condicion" element={<ControlGastosPoliticasPage />} />
        <Route path="/app/productos-quimfa/politicas-condicion" element={<ProductosQuimfaPoliticasPage />} />
        <Route path="/app/almacen-mascotas/politicas-condicion" element={<AlmacenMascotasPoliticasPage />} />
        <Route path="/app/snake-juego/politicas-condicion" element={<SnakejuegoPage />} />
        <Route path="/app/one-travel/politicas-condicion" element={<OneTravelPoliticasPage />} />
        <Route path="/app/vao-pue/politicas-condicion" element={<VaoPuePoliticasPage />} />
        <Route path="/app/saga-mascotas/politicas-condicion" element={<SagaGym />} />

        <Route path="*" element={<ErrorPage />} />

      </Routes>
    </HashRouter>
  )
}

export default RutesScreen
